export const DELETE_API = '@dialog/DELETE_API';
export const DELETE_DATA_SOURCE = '@dialog/DELETE_DATA_SOURCE';
export const DELETE_USER = '@dialog/DELETE_USER';
export const UPDATE_USER = '@dialog/UPDATE_USER';
export const CREATE_USER = '@dialog/CREATE_USER';
export const CREATE_ORGANIZATION = '@dialog/CREATE_ORGANIZATION';
export const INVITE_USER = '@dialog/INVITE_USER';
export const UPDATE_ORGANIZATION = '@dialog/UPDATE_ORGANIZATION';
export const DELETE_ORGANIZATION = '@dialog/DELETE_ORGANIZATION';
